var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    {
      staticClass:
        "w-full flex items-end justify-center px-2 py-2 pointer-events-none sm:items-start sm:justify-end transition duration-500",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto",
        },
        [
          _c("div", { staticClass: "rounded-lg shadow-xs overflow-hidden" }, [
            _c("div", { staticClass: "p-4" }, [
              _c("div", { staticClass: "relative flex items-center" }, [
                _c(
                  "div",
                  { staticClass: "flex-shrink-0" },
                  [
                    _vm.status === "SUCCESS"
                      ? [
                          _c(
                            "svg",
                            {
                              staticClass: "h-5 w-5 text-green-400",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M5 13l4 4L19 7",
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm.status === "CAUTION"
                      ? [
                          _c(
                            "svg",
                            {
                              staticClass: "h-5 w-5 text-orange-400",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm.status === "WARNING"
                      ? [
                          _c(
                            "svg",
                            {
                              staticClass: "h-5 w-5 text-red-400",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636",
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm.status === "WELCOME"
                      ? [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "25",
                                height: "22",
                                viewBox: "0 0 25 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M2.53105 12.6054L11.0014 20.5132C11.3529 20.8414 11.817 21.0242 12.2998 21.0242C12.7826 21.0242 13.2467 20.8414 13.5982 20.5132L22.0686 12.6054C23.4936 11.2789 24.2998 9.41793 24.2998 7.47261V7.20074C24.2998 3.92418 21.9326 1.13043 18.7029 0.591364C16.5654 0.235114 14.3904 0.933552 12.8623 2.46168L12.2998 3.02418L11.7373 2.46168C10.2092 0.933552 8.03418 0.235114 5.89668 0.591364C2.66699 1.13043 0.299805 3.92418 0.299805 7.20074V7.47261C0.299805 9.41793 1.10605 11.2789 2.53105 12.6054Z",
                                  fill: "#F10519",
                                },
                              }),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "svg",
                            {
                              staticClass: "h-5 w-5 text-gray-400",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                },
                              }),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
                _c("div", { staticClass: "ml-3 w-0 flex-1" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-xs leading-none font-medium text-gray-900",
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                  _c(
                    "p",
                    { staticClass: "mt-2 text-sm leading-none text-gray-500" },
                    [_vm._v(" " + _vm._s(_vm.message) + " ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }